import React from 'react';
import Button, { models } from 'components/core/Button';
import toSlug from 'utils/toSlug';
import Modal from 'components/layout/Modal';
import Icon from 'components/core/Icon';
import {
  ButtonsContainer, Container, Text, Title, List, ListItem,
} from './styles';

export default function ModalDialog({
  icon,
  title,
  text,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  show,
  canClose,
  onCloseModal,
  listKey,
  list,
  isLoading,
  cy,
}) {
  return (
    <Modal cy={`modal-container-${cy}`} show={show} canClose={canClose} onCloseModal={onCloseModal} zIndex="1500">
      <Container>
        <Title data-cy={`modal-title-${cy}`}>
          {icon && (
            <Icon height="35px" name={icon} />
          )}
          {' '}
          {title}
        </Title>
        {
          text && (
            <Text data-cy={`modal-text-${cy}`}>
              {text}
            </Text>
          )
        }
        {
          list && (
            <List data-cy={`modal-list-${cy}`}>
              {list.map((item) => (
                <ListItem key={item}>{item[listKey]}</ListItem>
              ))}
            </List>
          )
        }
        <ButtonsContainer>
          {
            cancelLabel && (
            <Button
              type="button"
              model={models.modelBSecondary}
              onClick={onCancel}
              text={cancelLabel}
              width="150px"
              minWidth="unset"
              cy={`cancelButton-${toSlug(cancelLabel)}`}
            />
            )
       }
          {
            confirmLabel && (
            <Button
              type="button"
              model={models.modelB}
              onClick={onConfirm}
              text={confirmLabel}
              width="150px"
              state={isLoading ? 'loading' : 'default'}
              minWidth="unset"
              cy={`confirmButton-${toSlug(confirmLabel)}`}
            />
            )
       }
        </ButtonsContainer>
      </Container>
    </Modal>
  );
}

ModalDialog.defaultProps = {
  title: '',
  text: null,
  confirmLabel: null,
  cancelLabel: null,
  onCancel: () => { /* */ },
  onConfirm: () => { /* */ },
  show: false,
  canClose: true,
  onCloseModal: () => { /* */ },
};
